<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="editLark"
  >
    <lark-form
      ref="form"
      :form-data="formData"
      @submit="submitHandle"
    ></lark-form>
  </sliderBarDialogShell>
</template>

<script>
import { editLarkConfig } from '@/api/sys/robitConfig/lark'
import larkForm from '@/components/sys/robitCofig/lark/larkForm'

export default {
  name: 'editLark',
  components:{
    larkForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object
    }
  },
  data() {
    return {
      title: '编辑Lark应用',
    }
  },

  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(params){
      const doSubmit = () => editLarkConfig(params).then(() => {
        this.$refs.form.$refs.form.clearValidate();
        this.$refs.form.$refs.form.resetFields();
        this.$emit('edit-success');
        this.$refs.form.reset();
      });
      // 从含采集改为仅推送时，后端会自动禁用引用该应用的采集策略，先确认
      const hadCollect = (Number(this.formData.appRole) & 1) === 1;
      const keepsCollect = (Number(params.appRole) & 1) === 1;
      if(hadCollect && !keepsCollect){
        return this.$confirm('该应用将不再具备采集身份，引用它的采集策略会被自动禁用，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        // 第二参数只接 $confirm 的取消，不吞 doSubmit 的失败
        }).then(doSubmit, () => {});
      }
      return doSubmit();
    }
  }
}
</script>

<style>
@media screen and (min-width: 768px) {
  .editLark.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
